import { useEffect, useState } from "react"
import { Data, Modal, ModalId, useUIState } from "../../../../features/ui"
import { TaxIdForm } from "./taxIdForm"

type Props = {
    data?: Data
    isMain?: boolean
    onSubmit: (taxId: number, isMain: boolean) => void
}

export const TaxIdFormModal = (props: Props) => {
    const { data, isMain, onSubmit } = props
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()
    const createMode = !data

    useEffect(() => setKey(key + 1), [openedModal])
    
    return (
        <Modal
            modalId={ModalId.COMPANY_TAX_IDS}
            title={createMode ? 'Agregar CUIT' : 'Editar CUIT'}
            actions={[]}
        >
            <TaxIdForm
                key={key}
                data={data}
                isMain={isMain}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}
